import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Peptides API
export const peptideApi = {
  getAll: async (category = null) => {
    const params = category && category !== 'All' ? { category } : {};
    const response = await api.get('/api/peptides/', { params });
    return response.data;
  },
  
  getById: async (id) => {
    const response = await api.get(`/api/peptides/${id}`);
    return response.data;
  },
  
  create: async (peptideData) => {
    const response = await api.post('/api/peptides/', peptideData);
    return response.data;
  },
  
  update: async (id, peptideData) => {
    const response = await api.put(`/api/peptides/${id}`, peptideData);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await api.delete(`/api/peptides/${id}`);
    return response.data;
  },
};

// FAQs API
export const faqApi = {
  getAll: async () => {
    const response = await api.get('/api/peptides/faq/all');
    return response.data;
  },
  
  create: async (faqData) => {
    const response = await api.post('/api/peptides/faq', faqData);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await api.delete(`/api/peptides/faq/${id}`);
    return response.data;
  },
};

// Benefits API
export const benefitsApi = {
  getAll: async () => {
    const response = await api.get('/api/peptides/benefits/all');
    return response.data;
  },
  
  create: async (benefitData) => {
    const response = await api.post('/api/peptides/benefits', benefitData);
    return response.data;
  },
};

// Contact API
export const contactApi = {
  submit: async (messageData) => {
    const response = await api.post('/api/contact/', messageData);
    return response.data;
  },
  
  getAll: async () => {
    const response = await api.get('/api/contact/');
    return response.data;
  },
  
  markAsRead: async (id) => {
    const response = await api.put(`/api/contact/${id}/read`);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await api.delete(`/api/contact/${id}`);
    return response.data;
  },
};

// Blog API
export const blogApi = {
  getAll: async (publishedOnly = true) => {
    const response = await api.get('/api/blog/', { params: { published_only: publishedOnly } });
    return response.data;
  },
  
  getBySlug: async (slug) => {
    const response = await api.get(`/api/blog/${slug}`);
    return response.data;
  },
  
  create: async (postData) => {
    const response = await api.post('/api/blog/', postData);
    return response.data;
  },
  
  delete: async (slug) => {
    const response = await api.delete(`/api/blog/${slug}`);
    return response.data;
  },
};

export default api;

// Convenience exports for backward compatibility
export const fetchPeptides = peptideApi.getAll;
export const fetchFAQs = faqApi.getAll;
export const fetchBenefits = benefitsApi.getAll;
